import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-calendar@9.6.0@rc-calendar/es/index.js
// module id = 252
// module chunks = 0 1